// extracted by mini-css-extract-plugin
module.exports = {"root":"bookingSchedules_root__DAxmI","scheduleTrigger":"bookingSchedules_scheduleTrigger__qN7mh"};